export default "__VITE_ASSET__Dt6YjNT$__"